import axios, { AxiosResponse } from "axios";

export const instance = axios.create({
  // baseURL: "https://api.aimetafi.io/",
  baseURL: "https://graph.aisolars.co/graphql",
  headers: {
    Accept: "application/json",
  },
});

instance.interceptors.request.use(
  async (config) => {
    const Token: any = localStorage.getItem("Token");
    //@ts-ignore
    // config.headers = {
    //   ...config.headers,
    //   "AMFI-User-Token": Token,
    // };
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  function (error) {
    if (error.response) {
      return Promise.reject({
        error: error?.response,
        status: error.response.status,
        message: error.response.data.message,
      });
    } else if (error.request) {
      return Promise.reject(error.request);
    } else {
      return Promise.reject(error);
    }
  }
);